
/*-----------------------------------------------------------------*/
//     Core Functions
/*-----------------------------------------------------------------*/

//user entered zip code or loaded saved
function EnteredZipCode(zip_code){
  debug.func(console_pre + arguments.callee.name, console_colors);
  if(!zip_code){
    alert("Please enter your delivery Zip Code.");
    return;
  }

  $.cookie("selected_zip_code", zip_code);
  $(".selected_zip_code").text(zip_code);
  $("#zip_code_picker").val(zip_code);
  ShowPickedZipCode();
  ShowEstimatedDeliveryDate(); 
  EnableCheckOutButton();
  debug.log("Ajax Start: googleapis");
  $.ajax({
    type: 'POST',
    url: "https://maps.googleapis.com/maps/api/geocode/json?address="+zip_code+"&key=AIzaSyAqWpPbIhjVXpoEfPF73tOaBUQ_8tGoTGA",
    success: (function(_this) {
      debug.log("Ajax End: googleapis");
      return function(data) {
        debug.log(data);
        if (data["status"] === "OK") {
          //debug.log(data["results"][0]);
          var zip;
          var state;
          var country;

          var location_info = [];

          if(data["results"].length >= 1){
            $.each(data["results"][0]["address_components"], function (o, address_comp) {
              var comp_type = address_comp["types"][0];
              if(comp_type == "postal_code"){
                zip = address_comp["short_name"];
              }
              if(comp_type == "administrative_area_level_1"){
                state = address_comp["short_name"];
              }
              if(comp_type == "country"){
                country = address_comp["short_name"];
              }

            });
          }
          

          location_info = {
            "postal_code" : zip,
            "region" : state,
            "country_code" : country,
          }

          //debug.log(location_info);

          //LoadCalendarStart();
          
          SaveLocationToCookie(location_info);
          var StateRulesInfo = GetRulesInfoByState(location_info.region);
          if(StateRulesInfo){
            UpdateCalendarAvailability(StateRulesInfo);
            InitCustomLocationBasedRules();
          }

          //LoadCalendarStart();
          debug.log(ship_asap);
          if(ship_asap){
            ShipAsap();
            //ShowCheckoutButton();
            //EnableCheckOutButton();
            //FinalizePickDate();
          }else{
            scanningForASAPDate = false;
            lookForASAPDate = false;
            debug.log(delivery_date);
            updateDateFromString(delivery_date);
            $("#delivery_pick_date").prop("checked", true);
            FinalizePickDate();
            //console.log("loaginf next");
            //LoadNextAvailableDate();
          }
          
          //$('input#user_account_attributes_address_attributes_city').val(data["results"][0]["address_components"][1]["long_name"]);
          //return $('select#user_account_attributes_address_attributes_state').val(data["results"][0]["address_components"][4]["long_name"]);
        }
      };
    })(this)
  });
}

//populate variables for available dates
function UpdateCalendarAvailability(state_info){
  debug.func(console_pre + arguments.callee.name, console_colors);
  disabled_transit_days = [];
  var todays_date = new Date();
  var disable_available_date = new Date();
  var disable_available_date_value;


  var ups_transit_time = state_info.ups_transit_time;
  var cake_in_cart = isThereCakeInCart();
  if(cake_in_cart){
    if(ups_transit_time == 1){
      allow_sunday = false;
      allow_monday = false;
      allow_tuesday = false;
      allow_wednesday = true;
      allow_thursday = true;
      allow_friday = true;
      allow_saturday = true;

      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 0);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
	  //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 1);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
    }
    if(ups_transit_time == 2){
      allow_sunday = false;
      allow_monday = false;
      allow_tuesday = false;
      allow_wednesday = true;
      allow_thursday = true;
      allow_friday = true;
      allow_saturday = true;
      
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 0);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 1);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
	  //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 2);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
    }
    if(ups_transit_time == 3){
      allow_sunday = false;
      allow_monday = false;
      allow_tuesday = false;
      allow_wednesday = false;
      allow_thursday = true;
      allow_friday = true;
      allow_saturday = true;

      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 0);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 1);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 2);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 3);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
		
    }
  }else{
    if(ups_transit_time == 1){
      
      allow_monday = false;
      allow_tuesday = true;
      allow_wednesday = true;
      allow_thursday = true;
      allow_friday = true;
      allow_saturday = false;
      allow_sunday = false;
      
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 0);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 1);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
    }
    if(ups_transit_time == 2){
      
      allow_monday = false;
      allow_tuesday = false;
      allow_wednesday = true;
      allow_thursday = true;
      allow_friday = true;
      allow_saturday = true;
      allow_sunday = false;
        
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 0);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 1);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 2);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
    }
    
    if(ups_transit_time == 3){
      
      allow_monday = false;
      allow_tuesday = false;
      allow_wednesday = false;
      allow_thursday = true;
      allow_friday = true;
      allow_saturday = true;
      allow_sunday = false;
      
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 0);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 1);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 2);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
      //disable date ahead
      disable_available_date.setDate(todays_date.getDate() + 3);
      disable_available_date_value = $.datepicker.formatDate("yy-mm-dd", disable_available_date);
      disabled_transit_days.push(disable_available_date_value);
    }
  }
/*
  console.log(disabled_transit_days);
  console.log("allow_sunday: " + allow_sunday);
  console.log("allow_monday: " + allow_monday);
  console.log("allow_tuesday: " + allow_tuesday);
  console.log("allow_wednesday: " + allow_wednesday);
  console.log("allow_thursday: " + allow_thursday);
  console.log("allow_friday: " + allow_friday);
  console.log("allow_saturday: " + allow_saturday);
  */
  RefreshDatePicker();
  //GetNextAvailableDate();
}

//load allowed dates onto calendar. if current selected date (from saved) is not allowed. default to ASAP
function LoadCalendarStart(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $('#calendar_wrapper').datepicker({
    dateFormat: "yy-mm-dd", 
    inline: true,
    minDate: +1,
    maxDate: '+6M',
    beforeShowDay: function(date) {
      //which days are not allowed based on zip code
      var show = true;
      if(!allow_sunday){
        if(date.getDay()==0){show=false;}
      }
      if(!allow_monday){
        if(date.getDay()==1){show=false;}
      }
      if(!allow_tuesday){
        if(date.getDay()==2){show=false;}
      }
      if(!allow_wednesday){
        if(date.getDay()==3){show=false;}
      }
      if(!allow_thursday){
        if(date.getDay()==4){show=false;}
      }
      if(!allow_friday){
        if(date.getDay()==5){show=false}
      }
      if(!allow_saturday){
        if(date.getDay()==6){show=false;}
      }
      
      var string = $.datepicker.formatDate('yy-mm-dd', date);
      if(disabled_dates.indexOf(string) != -1){
        show=false;
      }
      
      var string = $.datepicker.formatDate('yy-mm-dd', date);
      if(disabled_transit_days.indexOf(string) != -1){
        show=false;
      }

      var cake_in_cart = isThereCakeInCart();

      if(cake_in_cart){
        if(disabled_cake_dates.indexOf(string) != -1){
          show=false;
        }
      }
      
      var string = $.datepicker.formatDate('yy-mm-dd', date);
      if(maxxed_order_dates.indexOf(string) != -1){
        show=false;
      }

      
      return [show];
    },

    //when changed months, re analyze which dates are available
    onChangeMonthYear: function () {
      lookForASAPDate = true;
      scanningForASAPDate = true;
      LoadMonthlyOrdersLimits();
    },

    //the user selected a date
    onSelect: function () {
      if(scanningForASAPDate){
        return; 
      }
      LoadMonthlyOrdersLimits();
      //FinalizePickDate();
    }
  });

  //after the calendar loaded the available dates
  //GetNextAvailableDate();
  LoadMonthlyOrdersLimits();
}

//customer accepted the selected date.
function FinalizePickDate(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  UpdateInputDateValues();
  UpdateOrderAttributes();
  //ShowCheckoutButton();
  //EnableCheckOutButton();
  $(".calendar_snippet").hide();
}


function UpdateInputDateValues(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $('#date').attr('value',$('#calendar_wrapper').val());
  var calendar_date = $("#calendar_wrapper").datepicker('getDate');
  calendar_date = $.datepicker.formatDate("DD, MM d, yy", calendar_date);
  $(".populate_delivery_date").html(calendar_date);
}






function LoadMonthlyOrdersLimits(){
  if(CurrentMonthLoaded()){
    setTimeout(function(){ 
      FinishLoadingCalendar();
    },100);

    return;
  }

  debug.func(console_pre + arguments.callee.name, console_colors);
  gettingMonthData = true;
  var date_value = $('#date').val();
  var picker = $("#calendar_wrapper").data("datepicker");
  var date = new Date(picker.selectedYear, picker.selectedMonth, 1);
  var date_value = $.datepicker.formatDate("yy-mm-dd", date);

  ShowCalendarLoader();

  loaded_month = picker.selectedMonth + 1;
  loaded_year = picker.selectedYear;

  debug.log("Ajax Start: GetMonthOrders");
  $.ajax({
    url: 'https://coldfox.net/apps/taylor-chip/bakers-dashboard/version/1.4/server/functions.php',
    data: { func: 'GetMonthOrders', data1: date_value },
    type: 'POST',
    success: function(data) {
      debug.log("Ajax End: GetMonthOrders: " + date_value);
      if (data) {
        //console.log(JSON.parse(data));
        if(!$("#calendar_wrapper .ui-datepicker-calendar").hasClass("loaded-month")){
          $("#calendar_wrapper .ui-datepicker-calendar").addClass("loaded-month"); 
          if(JSON.parse(data)["orders"]){
            var json_data = JSON.parse(data)["orders"];
            let key = "preferred_delivery_date";
            var orders_with_occ = findOcc(json_data, key);
            orders_occurrences = orders_with_occ;
            
            var maxxed_order_dates_temp = [];
            $.each(orders_occurrences, function( index, value ) {
              var date = value["preferred_delivery_date"].split(' ')[0];
              var num_of_orders = value["occurrence"];
              if(num_of_orders >= max_orders_per_day){  
                maxxed_order_dates_temp.push(date);
              }



            });
            maxxed_order_dates = maxxed_order_dates_temp;
            debug.log(orders_with_occ);
          }
        }
        FinishLoadingCalendar();
      }
    },
    error: function() {},
    complete: function() {
    }
  });
}



/*-----------------------------------------------------------------*/
//     Button Functions
/*-----------------------------------------------------------------*/
function ShipAsap(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  //scanningForASAPDate = true;
  $(".block-delivery-asap").hide();
  $(".block-ship-asap-msg").show();
  $(".calendar_snippet").hide();
  $("#delivery_ship_asap").prop("checked", true);  
  scanningForASAPDate = false;
  lookForASAPDate = true;
  LoadMonthlyOrdersLimits();
}

function PickDeliveryDate(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  //scanningForASAPDate = false;
  $(".block-delivery-asap").show();
  $(".block-ship-asap-msg").hide();
  DisableCheckOutButton();
  $(".calendar_snippet").show();
  $("#delivery_pick_date").prop("checked", true);
  scanningForASAPDate = false;
  lookForASAPDate = false;
  LoadMonthlyOrdersLimits();
}









function RefreshDatePicker(){
  //debug.func(console_pre + arguments.callee.name, console_colors);
  $( "#calendar_wrapper" ).datepicker("refresh");
}

function isThereCakeInCart(){
  var cake_in_cart = $("cart-notification #cart-notification-product .product-in-cart[data-product_id="+cookieCakeID+"]").length;
  return cake_in_cart;
}






function GetASAPShipDate() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  if(scanningForASAPDate){
    return; 
  }
  GetNextAvailableDate();
}


function GetNextAvailableDate(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  var parsed_shipdate = new Date();
  var try_shipdate = parsed_shipdate;
  try_shipdate.setDate(parsed_shipdate.getDate());
  var available_date = getAvailableDateFordward(try_shipdate);
  //console.log(try_shipdate);
  UpdateInputDateValues();

  if(!scanningForASAPDate){
    lookForASAPDate = false;
    UpdateOrderAttributes();
  }
  //
}


function getAvailableDateFordward(date) {
  debug.func(console_pre + arguments.callee.name, console_colors);
  scanningForASAPDate = true;
  var available_date = new Date();

  for(i=0;i<200;i++){
    var try_shipdate = new Date();
    try_shipdate.setDate(available_date.getDate() + i + 3);

    updateDate($.datepicker.formatDate("yy-mm-dd", try_shipdate));
    var calendar_date = $("#calendar_wrapper").datepicker('getDate');

    RefreshDatePicker();
    if (!$("#calendar_wrapper .ui-datepicker-current-day").hasClass("ui-datepicker-unselectable")) {
      available_date = calendar_date;
      break;
    }
  }
  scanningForASAPDate = false;
  RefreshDatePicker();
  return available_date;
}



function updateDate(date) {
  //debug.func(console_pre + arguments.callee.name, console_colors);
  $('#calendar_wrapper').datepicker({ dateFormat: 'Y-mm-dd' }).datepicker('setDate', date);
  $('#calendar_wrapper .ui-datepicker-current-day').click();

}

function updateDateFromString(date) {
  debug.func(console_pre + arguments.callee.name, console_colors);
  if(!date){
    return false;
  }
  var arr_dateText = date.split("-");
  var date_year = parseInt(arr_dateText[0], 10);
  var date_month = parseInt(arr_dateText[1], 10) - 1;
  var date_day = parseInt(arr_dateText[2], 10);
  var date_as_obj = new Date(date_year, date_month, date_day);
  updateDate(date_as_obj);
}



function CurrentMonthLoaded(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  var picker = $("#calendar_wrapper").data("datepicker");
  var current_month_loaded = false;
  if(loaded_month == picker.selectedMonth + 1 && loaded_year == picker.selectedYear){
    current_month_loaded = true;
  }
  return current_month_loaded;
}


/*-----------------------------------------------------------------*/
//      Show / Hide Functions
/*-----------------------------------------------------------------*/

function ShowCheckoutButton(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".next-checkout-button").text("Checkout");
  $(".next-checkout-button").show();
  $(".next-delivery-button").hide();
}


function DisableCheckOutButton(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".next-checkout-button").addClass("disabled");
}

function EnableCheckOutButton(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".next-checkout-button").removeClass("disabled");
}


function ShowCalendarLoader(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".calendar_loaded").hide();
  $(".loading.calendar_loader").show();
}

function HideCalendarLoader(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".calendar_loaded").show();
  $(".loading.calendar_loader").hide();
}


function FinishLoadingCalendar(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  RefreshDatePicker();
  if(lookForASAPDate){
    GetASAPShipDate();
  }
  HideCalendarLoader();
}


function ShowPickedZipCode(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".zip_code_selected_wrapper").show(); 
  $(".zip_code_input_wrapper").hide(); 
  //ShowEstimatedDeliveryDate();
}

function ShowZipCodePicker(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".zip_code_selected_wrapper").hide(); 
  $(".zip_code_input_wrapper").show();
  HideEstimatedDeliveryDate();
  $("#zip_code_picker").focus();
}

function HideZipCodeWrapper(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".zip_code_picker_wrapper").hide(); 
}

function ShowZipCodeWrapper(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  ShowCheckoutButton();
  DisableCheckOutButton();
  $(".zip_code_picker_wrapper").show();
  $("#zip_code_picker").focus();

  debug.log($("#zip_code_picker").val());
  if($("#zip_code_picker").val()){
    EnableCheckOutButton();
  }
  /*
  if(HasCookie("selected_zip_code")){
    var zip_code = $.cookie("selected_zip_code");
    $("#zip_code_picker").val(zip_code);
    EnteredZipCode(zip_code);
  }else{
    $("#zip_code_picker").focus();
  }*/
}


function ShowEstimatedDeliveryDate(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".block-delivery-asap").show();
  ShowDeliveryRadioButtons();
}

function HideEstimatedDeliveryDate(){
  debug.func(console_pre + arguments.callee.name, console_colors);
  $(".block-delivery-asap").hide();
  HideDeliveryRadioButtons();
}


function ShowDeliveryRadioButtons(){
  debug.func(console_pre + arguments.callee.name, console_colors);
   $(".delivery_date_radios").show();
}

function HideDeliveryRadioButtons(){
  debug.func(console_pre + arguments.callee.name, console_colors);
   $(".delivery_date_radios").hide();
}
